module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Article-w720.d6477772.webp";